/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Spanish (es) string table — Shop landing page
   English is the source of truth in the HTML; this file supplies the
   Spanish counterpart for each shop.* key. Missing keys fall back to
   English (see i18n.js). Claim-bearing copy: faithful renderings only,
   no strengthening or embellishment. The only standing discount is the
   routine-builder 10% (auto-applied at checkout for 2+ serums).

   House voice: calm, exact, short. No em dashes in prose (use periods,
   commas, or the mid-dot · ). EXCEPTION: combo card labels keep the
   existing em dash ("Serum C — Brightening"), mirrored faithfully.
   Informal "tú". Product names, prices and proper nouns stay as-is.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.es = window.TD_I18N.es || {};
  Object.assign(window.TD_I18N.es, {

    /* ── Nav (page-specific) ── */
    'shop.nav.build': 'Construye una rutina',

    /* ── Serum grid ── */
    'shop.grid.title': 'Cuidado de la piel sin concesiones',
    'shop.addcart': 'Añadir al carrito',
    'shop.time.day': 'Día',
    'shop.time.night': 'Noche',
    'shop.time.both': 'Día y noche',
    'shop.card.c.benefit': 'Protege, ilumina y reafirma con vitamina C pura.',
    'shop.card.a.benefit': 'Renovación impulsada por retinol mientras duermes.',
    'shop.card.o.benefit': 'Da energía a las células y devuelve la luminosidad visible.',
    'shop.card.m.benefit': 'Repara la barrera de hidratación. En profundidad y de forma duradera.',
    'shop.card.r.benefit': 'Reafirma y restaura. Reduce imperfecciones y textura desigual con el tiempo.',

    /* ── Benefit strip ── */
    'shop.strip.1.t': 'Sin conservantes',
    'shop.strip.1.b': 'Envase airless y resistente a la UV que protege cada activo. Sin estabilizadores, sin concesiones.',
    'shop.strip.2.t': 'Liberación transdérmica',
    'shop.strip.2.b': 'Un sistema portador sin agua lleva vitaminas activas más allá de la superficie hasta la dermis, donde ocurren la síntesis de colágeno y la renovación celular.',
    'shop.strip.3.t': '2 años de vida útil',
    'shop.strip.3.b': 'Sin agua significa sin crecimiento bacteriano. Estable y potente desde el primer uso hasta el último.',
    'shop.strip.4.t': 'Libre de crueldad',
    'shop.strip.4.b': 'Nunca testado en animales. Desarrollado clínicamente, entregado de forma responsable.',

    /* ── Combo builder ── */
    'shop.combo.label': 'Construye tu rutina',
    'shop.combo.h2': '¿Dos sérums o más?<br><em>Diez por ciento de descuento.</em>',
    'shop.combo.c.name': 'Serum C — Luminosidad',
    'shop.combo.c.desc': 'Vitamina C · Día · Manchas oscuras y luminosidad',
    'shop.combo.a.name': 'Serum A — Renovación',
    'shop.combo.a.desc': 'Vitamina A · Noche · Renovación celular y textura',
    'shop.combo.o.name': 'Serum O — Oxigenante',
    'shop.combo.o.desc': 'Vitamina O · Día · Vitalidad celular y tono',
    'shop.combo.m.name': 'Serum M — Hidratación',
    'shop.combo.m.desc': 'Vitamina M · Día + noche · Hidratación y barrera',
    'shop.combo.r.name': 'Serum R — Antioxidante',
    'shop.combo.r.desc': 'Resveratrol · Día + noche · Protección y longevidad',

    /* ── Combo summary sidebar ── */
    'shop.concern.label': 'Compra por necesidad de la piel',
    'shop.concern.placeholder': 'Elige una necesidad…',
    'shop.concern.firmness': 'Firmeza',
    'shop.concern.brightness': 'Luminosidad',
    'shop.concern.hydration': 'Hidratación',
    'shop.concern.finelines': 'Líneas finas',
    'shop.concern.darkspots': 'Manchas oscuras',
    'shop.concern.texture': 'Textura',
    'shop.concern.acnescars': 'Cicatrices de acné',
    'shop.concern.dullness': 'Falta de luminosidad',
    'shop.sum.title': 'Tu rutina',
    'shop.sum.empty': 'Elige sérums para empezar',
    'shop.sum.discount': 'Descuento de rutina (10%)',
    'shop.sum.total': 'Total',
    'shop.sum.addbtn': 'Añadir la rutina al carrito',
    'shop.sum.note': 'Envío gratuito en todo el mundo · 2 años de vida útil garantizados',

    /* ── Sample / Discovery Kit ── */
    'shop.samp.eyebrow': '¿No sabes por dónde empezar?',
    'shop.samp.title': 'Prueba los cinco<br><em>por $70.</em>',
    'shop.samp.body': 'El Transderma Discovery Kit contiene versiones de bolsillo de los cinco sérums. Es como nos descubrieron la mayoría de nuestros clientes de largo recorrido.',
    'shop.samp.cta': 'Consigue el Discovery Kit',
    'shop.samp.fine': '$5 de envío a todo el mundo · Se envía desde Estocolmo',
    'shop.samp.f1.t': 'Los cinco sérums',
    'shop.samp.f1.b': 'Formato de bolsillo de C, A, O, M y R, 3 ml cada uno. Alrededor de 7 días de uso constante por frasco.',
    'shop.samp.f2.t': 'Los cinco, lado a lado',
    'shop.samp.f2.b': 'Pasa cada fórmula por tu rutina la misma semana y encuentra las combinaciones que funcionan para tu piel.',
    'shop.samp.f3.t': 'Sin compromiso',
    'shop.samp.f3.b': 'Sabrás en una semana si Transderma es para ti. La mayoría lo sabe en días.',

    /* ── Gift voucher ── */
    'shop.gift.title': 'Regala <em>Transderma</em>',
    'shop.gift.sub': 'Un vale digital entregado por correo electrónico. Canjeable en cada sérum y en el Discovery Kit.',
    'shop.gift.btn': 'Compra ahora',

    /* ── Discovery Kit product page (shopify-theme/templates/product.transderma-discovery-kit.liquid) ── */
    'shop.kit.crumb.home': 'Inicio',
    'shop.kit.crumb.current': 'Discovery Kit',

    /* Hero */
    'shop.kit.eyebrow': 'Cinco sérums vitamínicos · Un kit',
    'shop.kit.tagline': 'Versiones de bolsillo de los cinco sérums Transderma. Alrededor de 7 días de uso diario con todo el kit. Prueba el sistema completo antes de decidirte por frascos de tamaño completo.',
    'shop.kit.price.meta': 'Cinco minifrascos · 3 ml cada uno',
    'shop.kit.addcart': 'Añadir al carrito · $70',
    'shop.kit.soldout': 'Agotado · vuelve pronto',
    'shop.kit.reserve': 'Reserva tu kit',

    /* Hero meta */
    'shop.kit.meta.inside': 'Qué incluye',
    'shop.kit.meta.inside.v': '5 minifrascos · 3 ml cada uno',
    'shop.kit.meta.lasts': 'Dura',
    'shop.kit.meta.lasts.v': '~7 días de uso diario',
    'shop.kit.meta.formula': 'Fórmula',
    'shop.kit.meta.formula.v': '100% activo, sin agua',
    'shop.kit.meta.shelf': 'Vida útil',
    'shop.kit.meta.shelf.v': '2 años, potente todo el tiempo',

    /* What's inside */
    'shop.kit.inside.label': 'Qué incluye',
    'shop.kit.inside.title': 'Cinco minifrascos.<br><em>Una rutina completa.</em>',
    'shop.kit.inside.intro': 'Cada minifrasco contiene suficiente sérum para aproximadamente 7 días de aplicación diaria. Úsalos por separado, en capas mañana y noche, o prueba combinaciones según tus necesidades.',
    'shop.kit.card.time.day': 'Día',
    'shop.kit.card.time.night': 'Noche',
    'shop.kit.card.time.both': 'Día + noche',
    'shop.kit.card.c.desc': 'Vitamina C pura. Ilumina, protege, uniforma el tono.',
    'shop.kit.card.a.desc': 'Retinol. Renovación celular y textura, mientras duermes.',
    'shop.kit.card.o.desc': 'PQQ. Energía celular, vitalidad, claridad.',
    'shop.kit.card.m.desc': 'Hialurónico. Hidratación, volumen, apoyo a la barrera.',
    'shop.kit.card.r.desc': 'Resveratrol. Defensa antioxidante y longevidad.',

    /* Why try the kit */
    'shop.kit.why.label': 'Por qué empezar aquí',
    'shop.kit.why.title': 'Encuentra tu rutina <em>antes</em> de comprometerte.',
    'shop.kit.why.intro': 'Un frasco de tamaño completo cuesta $175 y dura varias semanas de uso diario. El Discovery Kit es la forma más sencilla de averiguar qué sérums funcionan en tu piel, y qué combinaciones realmente marcan la diferencia para tus necesidades específicas.',
    'shop.kit.why.1.t': '~7 días de uso real.',
    'shop.kit.why.1.b': 'Suficiente sérum para aplicar mañana y noche durante alrededor de una semana y empezar a ver cambios en textura, tono e hidratación. Esto no es una muestra, es una rutina en marcha.',
    'shop.kit.why.2.t': 'Los cinco, lado a lado.',
    'shop.kit.why.2.b': 'Pasa cada fórmula por tu rutina de mañana y noche en la misma semana. El kit es la forma más rápida de aprender qué combinaciones realmente marcan la diferencia para tu piel.',
    'shop.kit.why.3.t': 'Los cinco por menos de medio frasco.',
    'shop.kit.why.3.b': 'Un único sérum Transderma de tamaño completo cuesta $175. El kit te da los cinco por $70: la manera más económica de averiguar a qué fórmulas responde realmente tu piel antes de decidirte.',

    /* How it works */
    'shop.kit.how.label': 'Cómo funciona',
    'shop.kit.how.title': 'Siete días. <em>Un descubrimiento.</em>',
    'shop.kit.how.intro': 'La mayoría de los clientes lo sabe en cinco días. Este es el camino que toman la mayoría.',
    'shop.kit.how.s1.t': 'Día 1 · Abre',
    'shop.kit.how.s1.b': 'Abre el kit. Elige la necesidad que coincida con la tuya: luminosidad, renovación o hidratación.',
    'shop.kit.how.s2.t': 'Días 1–3 · Prueba',
    'shop.kit.how.s2.b': 'Aplica tu rutina mañana y noche. Dos gotas, presionadas sobre piel limpia. Deja que cada capa se absorba 30 segundos.',
    'shop.kit.how.s3.t': 'Días 4–7 · Afina',
    'shop.kit.how.s3.b': 'Para el día siete sabrás a qué sérums responde tu piel. Cambia rutinas, aplica las capas de otra manera o simplifica a dos.',
    'shop.kit.how.s4.t': 'Día 8 · Escala',
    'shop.kit.how.s4.b': 'Pide frascos de tamaño completo de los sérums que funcionaron, en la rutina que construiste. Dos o más frascos = 10% de descuento.',

    /* Delivery / returns */
    'shop.kit.del.shipping.t': 'Envío',
    'shop.kit.del.shipping.b': 'Tarifa plana de $5 de envío en todo el mundo. Se envía desde Estocolmo, normalmente entre 3 y 7 días laborables. <a href="/pages/shipping-returns">Detalles de envío completos</a>.',
    'shop.kit.del.returns.t': 'Devoluciones',
    'shop.kit.del.returns.b': 'Una vez abierto, el Discovery Kit no es reembolsable. Los kits sin abrir pueden devolverse en un plazo de 14 días. <a href="/pages/shipping-returns">Política de devoluciones</a>.',
    'shop.kit.del.approved.t': 'Aprobado y registrado',
    'shop.kit.del.approved.b': 'Aprobado en laboratorio por Läkemedelsverket. Registrado conforme a la Legislación Europea de Cosméticos. Nunca testado en animales.'

  });
})();
